import React from 'react';

import SvgComponent from '../../SvgComponent';
import { STATIC_ROOT } from '../../../constants';

import './ModalHeaderComponent.scss';

export const ModalHeaderComponent = ({ urlRewritten, partner, i18n }) => {
    return (
        <section className="interstitiel-modal-header flex-container-h flex-center-alt">
            <SvgComponent src={`${STATIC_ROOT}/logo.svg`} width="110" height="36" />
            {partner && urlRewritten && (
                <div>
                    {i18n.HEADER_MSG}
                    <a href={urlRewritten} title={partner ? partner.name : ''}>
                        {i18n.CLICK_HERE}
                    </a>
                </div>
            )}
        </section>
    );
};



// WEBPACK FOOTER //
// ./src/components/pages/interstitiel/ModalHeaderComponent.js